import {connect} from 'react-redux';
import {ThermocyclerPoster as Component} from './ThermocyclerPoster';
import {
  showModal
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state) {
  return {
    levelSelected: state.notebook.levelSelected
  }
}

function mapDispatchToProps(dispatch) {
  return {
    showModal: (data) => {
      dispatch(showModal(data))
    }
  };
}

export const ThermocyclerPoster = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
